export function deepEqual<T>(a: T, b: T): boolean {
  if (a === b) return true;

  if (
    typeof a !== "object" ||
    typeof b !== "object" ||
    a === null ||
    b === null
  ) {
    return false;
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    return a.every((item, index) => deepEqual(item, b[index]));
  }

  const keysA = Object.keys(a as unknown as object);
  const keysB = Object.keys(b as unknown as object);

  if (keysA.length !== keysB.length) return false;

  return keysA.every((key) => {
    const valA = (a as Record<string, unknown>)[key];
    const valB = (b as Record<string, unknown>)[key];
    return deepEqual(valA, valB);
  });
}

export function returnDayOrDays(value: number) {
  if(value <= 1) return `${value} dia`;
  return `${value} dias`;
}